import React, { useState, useEffect } from 'react';
import './aefs.css';

const Artesaniashh2026 = () => {
   
  const [expandida, setExpandida] = useState(null);
    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >13.ª EDICIÓN DEL CONCURSO REGIONAL DE ARTESANÍAS DE LA HUASTECA HIDALGUENSE 2026
      
          </h3>

           <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
          </h5>

          {/* IMAGEN 2 */}
          <div className="hero">
            <h5>Resumen</h5>
              <p></p>
            <div className="contenedor">
              <img
                src="https://sebiso.hidalgo.gob.mx/docs/imgs/Artesaniashh2026.png"
                alt=""
                className={expandida === 2 ? "img expandida" : "img"}
                onClick={() => toggleImagen(2)}
              />
            </div>
          </div>

          <br />

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Consulta la convocatoria
          </h5>

          {/* BOTÓN PRINCIPAL */}
          <div className="botones">
            <a href="/Documento/202" className="btn-vino">
              Haz clic aquí
            </a>
          </div>

          <br />

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Obtén los formatos
          </h5>

          {/* BOTONES SECUNDARIOS */}
          <div className="botones">
            <a href="https://sebiso.hidalgo.gob.mx/docs/anexos/ANEXO_2.pdf" className="btn-vino">Anexo 2</a>
            <a href="https://sebiso.hidalgo.gob.mx/docs/anexos/ANEXO_3.pdf" className="btn-vino">Anexo 3</a>
            <a href="https://sebiso.hidalgo.gob.mx/docs/anexos/ANEXO_7.pdf" className="btn-vino">Anexo 7</a>
          </div>

          <br />

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            {/* TÍTULO DE LA IMAGEN */}
          </h5>

          {/* IMAGEN 1 */}
          <div className="hero">
            <div className="contenedor">
              <img
                src=""
                alt=""
                className={expandida === 1 ? "img expandida" : "img"}
                onClick={() => toggleImagen(1)}
              />
            </div>
          </div>

          <br />

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default Artesaniashh2026;